<template>
    <div>
        <div class="loading-full" v-if="flagBackgroundLoading" />
       
        <div style="max-width:1024px;margin:auto" v-if="flagLoaded">
            <div v-show="stepBuy != 3" class="back-step" @click="(!flagGroupCode & stepBuy == 1) || (!flagGroupCode && stepBuy == 2) ? backStep()  : (flagGroupCode & stepBuy == 1) ? goPlanPricesStep() :  backStepBuy()" 
                :style="stepBuy == 1 ? 'position:absolute' : null"
            >
                <div v-show="stepBuy == 1"><icon name="arrow-left" />{{$t('planesYPrecios.regresar')}}</div>
                <div v-show="stepBuy != 1"><icon name="arrow-left" />{{$t('planesYPrecios.regresar')}}</div>
            </div>
            <div v-if="stepBuy == 1"> 
                <h6 class="sub-title">{{ flagGroup ? $t('planesYPrecios.paso-5.titulo1') : $t('planesYPrecios.paso-5.titulo1-student') }}<span>{{$t('planesYPrecios.paso-5.titulo1-2')}}</span></h6>
                <div class="card">
                    <div class="card-body cod-compra w-50">
                        <b-form-group>
                            <b-form-input id="input-code" v-model.trim="group.code" type="text" name="txtCodeGroup"  :placeholder="$t('planesYPrecios.paso-5.placeholder-codigo')" autofocus 
                            required  v-bind:class="{ error: $v.group.code.$error}" @blur="$v.group.code.$touch()"  />
                            <span class="error-input">{{ validationMsgCodeGroup($v.group.code)}}</span>
                            <span  :class="codeValid ? 'valid-input': 'error-input'" v-if="!$v.group.code.$error && message">{{message}}</span>
                        </b-form-group>
                        <b-button v-if="!isLoading" variant="primary"  @click="procesarGroupCode">
                            {{$t('planesYPrecios.paso-5.button-1')}}
                        </b-button>
                        <b-button v-else  variant="primary" :disabled="true">
                            {{$t('reusables.loading')}}
                        </b-button>
                    </div>
                </div>
                <div v-if="!codeValid" class="cod-compra-contact card mt-4">
                    <div class="card-body">
                        <h6 class="sub-title"><span>{{$t('planesYPrecios.paso-5.text-1')}}</span></h6>
                        <p>{{$t('planesYPrecios.paso-5.text-1-2')}}</p>
                        <div class="links">
                            <b-link :href="'mailto:'+ CONSTANTES.EMAIL">
                                <icon name="msg" />
                                <span>{{CONSTANTES.EMAIL}}</span>
                            </b-link>
                            <b-link :href="'https://wa.me/' + CONSTANTES.WHATSAPP_URL" target="_blank">
                                <icon name="whatsapp" />
                                <span>{{CONSTANTES.WHATSAPP}}</span>
                            </b-link>
                        </div>
                        <img class="img" src="@/assets/img/img-contact.png">
                    </div>
                    
                </div>
                <div v-else class="content-valid card mt-4">
                    <div class="card-body padding-short">
                        <h6 class="sub-title" v-if="flagGroup"><span>{{$t('planesYPrecios.paso-5.list.1-2')}} {{objInformation.code}}</span></h6>
                        <b-row class="mb-3">
                            <b-col>
                                <p v-if="objInformation.company">{{$t('planesYPrecios.paso-5.text-2.1')}}
                                    <ul><li>{{objInformation.company}}</li></ul>
                                </p>
                                <p>{{$t(flagGroup ? 'planesYPrecios.paso-5.text-2.2' : 'view-schedule.titleClass.1')}}
                                    <ul>
                                        <li v-for="person in objInformation.persons" :key="person.id" :id="'user_'+person.id">
                                            {{person.strFullName}}<template v-if="person.flagRepresentative"><icon class="ml-5 leader-star" name="star-2" /></template>
                                        </li>
                                    </ul>
                                </p>
                            </b-col>
                            <b-col>
                                <p>{{$t('planesYPrecios.paso-5.text-2.3')}}
                                    <ul>
                                        <li v-for="item in objInformation.subjects" :key="item.id" :id="'subjetc_'+item.id">
                                            {{item.name}}
                                        </li>
                                    </ul>
                                </p>
                                <p>{{$t('planesYPrecios.paso-5.text-2.4')}}
                                    <ul><li>{{ objInformation.flagPlanTest ? objInformation.name : $t('planesYPrecios.paso-5.text-2.4-1', {duration: objInformation.duration})}}</li></ul>
                                </p>
                                <p>{{$t('planesYPrecios.paso-5.text-2.5')}}
                                    <ul><li>{{objInformation.strPrice}}</li></ul>
                                </p>

                            </b-col>
                        </b-row>
                        <div class="text-center mt-5">
                            <b-button v-if="!isLoading" variant="primary" @click="IrSeccionPagar">
                                {{$t('planesYPrecios.paso-5.button-2')}}
                            </b-button>
                            <b-button v-else  variant="primary" :disabled="true">
                                {{$t('reusables.loading')}}
                            </b-button>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="stepBuy == 2 && objInformation">
                <div class="card mt-4">
                    <div class="card-body">
                        <ul class="list-horizontal-gray mb-5">
                            <li v-if="flagGroup">
                                <h6>{{$t('planesYPrecios.paso-5.list.1')}}</h6>
                                <p>{{objInformation.flagGroup ? objInformation.code : "-"}}</p>
                            </li>
                            <li style="flex: 1.5">
                                <h6>{{ flagGroup ? $t('planesYPrecios.paso-5.list.2') : $t('planesYPrecios.paso-5.placeholder-codigo-title') }}</h6>
                                <p>{{objInformation.flagGroup ? objInformation.purchaseCode : "-"}}</p>
                            </li>
                            <li>
                                <h6>{{$t('planesYPrecios.paso-5.list.3')}}</h6>
                                <p>{{objInformation.flagPlanTest ? objInformation.name : $t('planesYPrecios.paso-5.text-2.4-1', {duration:objInformation.duration})}} </p>
                            </li>
                            <li>
                                <h6>{{$t('planesYPrecios.paso-5.list.4')}}</h6>
                                <p>{{objInformation.strPrice}}</p>
                            </li>
                            <li>
                                <h6>{{$t('planesYPrecios.paso-5.list.5')}}</h6>
                                <p>{{objInformation.levelAbrev}}</p>
                            </li>
                        </ul>
                        <b-row>
                            <b-col class="content-valid">
                                <p>{{$t('planesYPrecios.paso-5.list.6')}}
                                    <ul class="scroll">
                                        <li v-for="item in objInformation.subjects" :key="item.id" :id="'subjetc_'+item.id">
                                            {{item.name}}
                                        </li>
                                    </ul>
                                </p>
                            </b-col>
                            <b-col class="content-valid ml-5"> 
                                <p>{{flagGroup ? $t('planesYPrecios.paso-5.listado.sub-titulo') : $t('view-schedule.titleClass.1')}}:
                                    <ul class="scroll">
                                        <li v-for="person in objInformation.persons" :key="person.id" :id="'user_'+person.id">
                                            {{person.strFullName}}<template v-if="person.flagRepresentative"><icon class="ml-5 leader-star" name="star-2" /></template>
                                        </li>
                                    </ul>
                                </p>
                            </b-col>
                        </b-row>
                    </div>
                </div>
                <b-row class="mt-4">
                    <b-col cols="6">
                        <div class="card card-body text-center d-flex h-100 p-4">
                            <h6 class="sub-title mb-4"><span>{{$t('planesYPrecios.paso-5.finish.1')}}</span></h6>
                            <p style="font-size:15px">{{$t('planesYPrecios.paso-5.finish.2')}}</p>
                            <p class="mb-4">
                                <span v-html="$t('planesYPrecios.paso-5.finish.3', {url:pdf.PDF_TERMS})">
                                </span>
                            </p>
                            <b-button v-if="!isLoading" variant="primary" class="d-flex m-auto" @click="showNiubizPaymentForm">
                                {{$t('planesYPrecios.paso-5.pay.button')}} 
                            </b-button>
                            <b-button v-else variant="primary" class="d-flex m-auto" :disabled="true">
                                {{$t('reusables.loading')}}
                            </b-button>
                        </div>
                    </b-col>
                    <b-col cols="6">
                        <div class="card card-body text-center d-flex h-100 p-4">
                            <h6 class="sub-title mb-4"><span>{{$t('planesYPrecios.paso-5.factura.1')}}</span></h6>
                            <p class="mb-0" style="font-size:15px">{{$t('planesYPrecios.paso-5.factura.2')}}</p>
                            <div class="links">
                                <b-link :href="'mailto:'+ CONSTANTES.EMAIL">
                                    <icon name="msg" />
                                    <span>{{CONSTANTES.EMAIL}}</span>
                                </b-link>
                                <b-link :href="'https://wa.me/' + CONSTANTES.WHATSAPP_URL" target="_blank">
                                    <icon name="whatsapp" />
                                    <span>{{CONSTANTES.WHATSAPP}}</span>
                                </b-link>
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <!-- <b-card no-body class="mb-4">
                    <b-tabs card>
                    <b-tab active @click="selectTabMethod(PAYMENT_METHODS.CREDIT_DEBIT_CARD)" >
                        <template #title>
                            <b-icon icon="circle-fill" aria-hidden="true" id="icontab1" :class="selectTab ? 'fill':'noFill' "></b-icon> {{$t('planesYPrecios.paso-5.pay.sub-titulo-1')}}
                        </template>
                        <b-card-text>
                            <p>{{$t('planesYPrecios.paso-5.pay.text-1.1')}}</p>
                            <section>
                                <div class="buttons-input">
                                    <button>{{$t('planesYPrecios.paso-5.pay.text-1.buttons.1')}}</button>
                                    <button>{{$t('planesYPrecios.paso-5.pay.text-1.buttons.2')}}</button>
                                    <button>{{$t('planesYPrecios.paso-5.pay.text-1.buttons.3')}}</button>
                                </div>
                                <label for="input-live">{{$t('planesYPrecios.paso-5.pay.text-1.2')}}</label>
                                <b-form-input id="txtNroTarjeta" v-model="creditCardInfo.cardNumber" ></b-form-input>
                            </section>
                            <section class="d-flex justify-content-between mt-4">
                                <div class="w-50">
                                    <label for="input-live">{{$t('planesYPrecios.paso-5.pay.text-1.3')}}</label>
                                    <b-form-input id="txtExpireDate"  v-model="creditCardInfo.expirationDate"></b-form-input>
                                </div>
                                <div>
                                    <label for="input-live">{{$t('planesYPrecios.paso-5.pay.text-1.4')}}</label>
                                    <b-form-input id="txtCCV"  v-model="creditCardInfo.cvv"  ></b-form-input>
                                </div>
                            </section>

                        </b-card-text>
                    </b-tab>
                    <b-tab @click="selectTabMethod(PAYMENT_METHODS.BANK_TRANSFER)">
                        <template #title>
                            <b-icon icon="circle-fill" aria-hidden="true" id="icontab2" :class="!selectTab ? 'fill':'noFill' "></b-icon> {{$t('planesYPrecios.paso-5.pay.sub-titulo-2')}}
                        </template>
                        <b-card-text>
                            <p>{{$t('planesYPrecios.paso-5.pay.text-2.0')}}</p>
                            <ol>
                                <li>{{$t('planesYPrecios.paso-5.pay.text-2.1')}}
                                    <span><p>{{$t('planesYPrecios.paso-5.pay.text-2.1-1')}}</p> 
                                        <ul>
                                            <li>{{$t('planesYPrecios.paso-5.pay.text-2.1-2')}}</li>
                                            <li>XXXXXXXXXXX</li>
                                            <li>{{$t('planesYPrecios.paso-5.pay.text-2.1-4')}}XXXXXXXXXXXXXXXXX</li>
                                        </ul>
                                    </span>
                                </li>
                                <li>{{$t('planesYPrecios.paso-5.pay.text-2.2')}}
                                    <ul>
                                        <li>{{$t('planesYPrecios.paso-5.pay.text-2.2-1')}}</li>
                                        <li>{{$t('planesYPrecios.paso-5.pay.text-2.2-2')}}</li>
                                        <li>{{$t('planesYPrecios.paso-5.pay.text-2.2-3')}}</li>
                                        <li>{{$t('planesYPrecios.paso-5.pay.text-2.2-4')}}</li>
                                    </ul>
                                </li>
                                <li>{{$t('planesYPrecios.paso-5.pay.text-2.3')}}
                                </li>
                            </ol>
                            <div class="links d-flex">
                            <p class="mb-0 mr-2">{{$t('planesYPrecios.paso-5.pay.text-2.4')}} </p>
                                <b-link href="#">
                                    <span>979 221 021</span>
                                </b-link>
                            </div>
                        </b-card-text>
                    </b-tab>
                    </b-tabs>
                </b-card>
                <b-button variant="primary" class="d-flex m-auto" @click="BuyPlan">{{$t('planesYPrecios.paso-5.pay.button')}}</b-button> -->
            </div>
            <div  v-if="stepBuy == 3 &&  objInformation" >
                <h6 class="sub-title">
                    {{$t('planesYPrecios.paso-5.exito.1')}} <span>{{$store.state.user.strFullName + "!"}}</span>
                </h6>
                <div class="card card-body p-5 text-center">
                    <p class="mb-4"><strong class="bold">{{$t('planesYPrecios.paso-5.exito.2')}}</strong> <br/>
                        {{$t('planesYPrecios.paso-5.exito.3')}}
                    </p>
                    <b-button variant="primary" class="d-flex m-auto" @click="$router.push({name:'horario'})"><icon class="mr-2" name="calendar" /> {{$t('planesYPrecios.paso-5.button-3')}}</b-button>
                </div>
                <b-row v-if="objInformation.flagGroup" class="mt-4">
                    <b-col cols="6">
                        <div class="card card-body p-5 d-flex h-100">
                            <h6 class="sub-title mb-4"><span class="d-flex align-items-center"><img src="@/assets/img/bag.png" alt="" class="mr-3"> {{$t('planesYPrecios.paso-5.sub-titulo-2')}}</span></h6>
                            <div class="content-valid">
                                <p>{{$t('planesYPrecios.paso-5.list.3')}}
                                    <ul><li>{{objInformation.flagPlanTest ? objInformation.name : $t('planesYPrecios.paso-5.text-2.4-1', {duration: objInformation.duration})}}</li></ul>
                                </p>
                                <p>{{$t('planesYPrecios.paso-5.list.4-2')}}
                                    <ul><li>{{objInformation.strPrice}}</li></ul>
                                </p>
                                <p>{{$t('planesYPrecios.paso-5.fail-purchase.info.nroPedido')}}
                                    <ul><li>{{objInformation.nroPedido}}</li></ul>
                                </p>
                                <p>{{$t('planesYPrecios.paso-5.fail-purchase.info.fechaHoraPedido')}}
                                    <ul><li>{{objInformation.transaccionFecha}}</li></ul>
                                </p>
                                <p>{{$t('planesYPrecios.paso-5.fail-purchase.info.tarjetaDatos')}}
                                    <ul><li>{{objInformation.tarjeta}}</li></ul>
                                </p>
                                <p>{{$t('planesYPrecios.paso-5.list.6')}}
                                    <ul>
                                        <li v-for="item in objInformation.subjects" :key="item.id" :id="'subjetc_'+item.id">
                                            {{item.name}}
                                        </li>
                                    </ul>
                                </p>
                            </div>
                        </div>
                    </b-col>
                    <b-col cols="6">
                        <div class="card card-body p-5 d-flex h-100">
                            <h6 class="sub-title mb-4"><span class="d-flex align-items-center"><img class="mr-3" src="@/assets/img/talking.png" >{{$t('planesYPrecios.paso-5.list.1-2')}} {{objInformation.code}}</span></h6>
                            <div class="content-valid">
                                <p v-if="objInformation.company">{{$t('planesYPrecios.paso-5.text-2.1')}}
                                    <ul><li>{{objInformation.company}}</li></ul>
                                </p>
                                <p>{{$t('planesYPrecios.paso-5.listado.sub-titulo')}}:
                                    <ul class="scroll">
                                        <li v-for="person in objInformation.persons" :key="person.id" :id="'user_'+person.id">
                                            {{person.strFullName}}<span v-if="person.flagRepresentative" class="ml-5" style="font-size: 13px">&#11088;</span>
                                        </li>
                                    </ul>
                                </p>
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <div v-else class="cod-compra-contact card mt-4">
                    <div class="card-body pt-4">
                        <h6 class="sub-title"><span class="text-left d-flex align-items-center"><img src="@/assets/img/bag.png" alt="" class="mr-3">{{$t('planesYPrecios.paso-5.sub-titulo-2')}}</span></h6>
                        <div class="content-valid">
                            <div class="d-flex w-100 pr-5 justify-content-between">
                                <p class="w-50">{{$t('planesYPrecios.paso-5.list.3')}}
                                    <ul style="width:inherit !important"><li>{{objInformation.flagPlanTest ? objInformation.name : $t('planesYPrecios.paso-5.text-2.4-1', {duration: objInformation.duration})}}</li></ul>
                                </p>
                                <p class="w-100" style="justify-content: space-evenly;">{{$t('planesYPrecios.paso-5.list.6')}}
                                    <ul>
                                        <li v-for="item in objInformation.subjects" :key="item.id" :id="'subjetc_'+item.id">
                                            {{item.name}}
                                        </li>
                                    </ul>
                                </p>
                            </div>
                            <div class="d-flex w-50 pr-1 justify-content-between">
                                <p class="w-100">{{$t('planesYPrecios.paso-5.list.4')}}
                                    <ul><li>{{objInformation.strPrice}}</li></ul>
                                </p>
                            </div>
                            <div class="d-flex w-50 mt-2 pr-1 justify-content-between">
                                <p class="w-100">{{$t('planesYPrecios.paso-5.fail-purchase.info.nroPedido')}}
                                    <ul><li>{{objInformation.nroPedido}}</li></ul>
                                </p>
                            </div>
                            <div class="d-flex w-50 mt-2 pr-1 justify-content-between">
                                <p class="w-100">{{$t('planesYPrecios.paso-5.fail-purchase.info.fechaHoraPedido')}}
                                    <ul><li>{{objInformation.transaccionFecha}}</li></ul>
                                </p>
                            </div>
                            <div class="d-flex w-50 mt-2 pr-1 justify-content-between">
                                <p class="w-100">{{$t('planesYPrecios.paso-5.fail-purchase.info.tarjetaDatos')}}
                                    <ul><li>{{objInformation.tarjeta}}</li></ul>
                                </p>
                            </div>
                        </div>
                        <img class="img img2" src="@/assets/img/shopping.png">
                    </div>
                </div>
            </div>
            <div  v-if="stepBuy == 4 &&  objInformation" >
                <h6 class="sub-title">
                    {{$t('planesYPrecios.paso-5.fail-purchase.1')}} <span>{{$store.state.user.strFullName + "!"}}</span>
                </h6>
                <div class="card card-body p-5 text-center">
                    <p class="mb-4">
                        <strong class="bold mb-4">{{$t('planesYPrecios.paso-5.fail-purchase.2')}}</strong> <br/>
                        {{$t('planesYPrecios.paso-5.fail-purchase.info.nroPedido')}} {{objInformation.nroPedido}} <br/>
                        {{$t('planesYPrecios.paso-5.fail-purchase.info.fechaHoraPedido')}} {{objInformation.transaccionFecha}}<br/>
                        {{$t('planesYPrecios.paso-5.fail-purchase.info.descripcionError')}} {{objInformation.descriptionPago}}   <br/>
                    </p>
                    <b-button v-if="!isLoading" variant="primary" class="d-flex m-auto" @click="goStepBuy()">
                        {{$t('planesYPrecios.paso-5.fail-purchase.btn')}} 
                    </b-button>
                    <b-button v-else variant="primary" class="d-flex m-auto" :disabled="true">
                        {{$t('reusables.loading')}}
                    </b-button>
                
                </div>
              
            </div>
            <div v-if="false"  >
                <div v-if="paymentMethodSelected == PAYMENT_METHODS.CREDIT_DEBIT_CARD">
                    <h6 class="sub-title d-flex justify-content-center">
                        {{$t('planesYPrecios.paso-5.valid-purchase.titulo')}}  
                        <span v-if="!flagGroup">{{objInformation.persons[0].firstName}}</span>
                        <span v-else>{{$t('planesYPrecios.paso-5.valid-purchase.sub-titulo-2')}} {{objInformation.purchaseCode}}</span>
                    </h6>
                    <div class="text-center">
                        <p>{{$t('planesYPrecios.paso-5.valid-purchase.text.1')}}</p>
                        <p>{{$t('planesYPrecios.paso-5.valid-purchase.text.2')}}</p>
                    </div>
                    <router-link to="/horario" >
                        <b-button variant="primary" class="d-flex m-auto">{{$t('planesYPrecios.paso-5.valid-purchase.button')}}</b-button>
                    </router-link>
                    <h6>{{$t('planesYPrecios.paso-5.valid-purchase.sub-titulo')}}</h6>
                    <div class="listado">
                        <span><p>{{$t('planesYPrecios.paso-5.text-2.4')}}</p> 
                            {{objInformation.flagPlanTest ? objInformation.name : $t('planesYPrecios.paso-5.text-2.4-1', {duration: objInformation.duration})}}
                        </span>
                        <span><p>{{$t('planesYPrecios.paso-5.text-2.5')}}</p> 
                                {{objInformation.strPrice}}
                        </span>
                        <span><p>{{$t('planesYPrecios.paso-5.text-2.3')}}</p> 
                            <ul>
                                <li v-for="item in objInformation.subjects" :key="item.id" :id="'subjetc_'+item.id">
                                    {{item.name}}
                                </li>
                            </ul>
                        </span>
                    </div>
                    <h6 class="mt-4" v-if="flagGroup" >{{$t('planesYPrecios.paso-5.valid-purchase.sub-titulo-2')}} {{objInformation.purchaseCode}}</h6>
                    <div class="listado" v-if="flagGroup">
                        <span v-if="objInformation.company"><p>{{$t('planesYPrecios.paso-5.text-2.1')}}</p> 
                            {{objInformation.company}}
                        </span>
                        <span><p>{{$t('planesYPrecios.paso-5.text-2.2')}}</p> 
                            <ul>
                                <li v-for="person in objInformation.persons" :key="person.id" :id="'user_'+person.id">
                                    {{person.strFullName}} <span v-if="person.flagRepresentative">{{$t('planesYPrecios.paso-5.text-2.2-1-1')}}</span>
                                </li>
                            </ul>
                        </span>
                    </div>

                </div>
                <div v-else>
                    <h6 class="sub-title d-flex justify-content-center">{{$t('planesYPrecios.paso-5.valid-purchase.stepBuy')}}</h6>
                </div>

                
            </div>
        

            <b-toast id="toast-check-modal-error" variant="none" no-close-button toaster="b-toaster-top-center">
                <img src="@/assets/img/ico-equis.png" style="margin-right: 10px; margin-top: -2px" />
                {{ message }}
            </b-toast>
            <b-modal id="modal-compra" :hide-footer="true" :hide-header="true" :centered="true">
                <img class="close" src="@/assets/img/close_red.png" @click="$bvModal.hide('modal-compra')">
                
                <p style="font-size:18px; color:red">
                    {{$t('planesYPrecios.paso-5.pay.payment-error')}}
                </p>
            </b-modal>
        </div>
    </div>
</template>

<script>
import { baseInstanceAxios } from '@/assets/js/axiosBase.js';
import { PAYMENT_METHODS, CONSTANTES, PDF} from '@/assets/js/appConstants'; 
import { required } from 'vuelidate/lib/validators';
import { validationMessage } from 'vuelidate-messages';
import { ValidateIsPlanActive, hideSidebar, openNiubizCheckoutForm, getCookie, deleteCookie } from '@/assets/js/util.js';
import * as Constants from "@/assets/js/appConstants";
const formMessagesCodeGroup = {
    required: function () {
        return this.$t('validations.formMessagesLogin.required')
    },
    
}
export default {
    data() {
        return {
            group:{
                code:""
            },
            flagLoaded: false,
            isLoading: false,
            btnDisabled:false,
            modalCompra: false, 
            objInformation: {},
            message: "",
            API_URL: process.env.VUE_APP_API_URL,
            NIUBIZ_MERCHANT_ID: process.env.VUE_APP_NIUBIZ_MERCHANT_ID,
            lstMessages: [this.$t("planesYPrecios.paso-5.mensajes-code-validacion.1"),
                          this.$t("planesYPrecios.paso-5.mensajes-code-validacion.2"),
                          this.$t("planesYPrecios.paso-5.mensajes-code-validacion.3"),
                          this.$t("planesYPrecios.paso-5.mensajes-code-validacion.4")
                          ],
            codeValid:false,
            selectTab:true,
            creditCardInfo:{
                cardNumber:"",
                expirationDate:"",
                cvv:""
            },
            stepBuy: 1,
            PAYMENT_METHODS:PAYMENT_METHODS,
            paymentMethodSelected:PAYMENT_METHODS.CREDIT_DEBIT_CARD,
            CONSTANTES: CONSTANTES,
            PurchaseNumberNiubiz: "",
            flagBackgroundLoading: false,
            pdf: PDF
        };
    },
    mounted() {
 
        if(this.modalCompra) {
            this.$bvModal.show('modal-compra')
        }
 
    },
    props:{
        backStep: {
			type: Function,
			default() {
				return {}
			}
		},
        groupData :{
			type: Object
		}
    },
    computed: {
		groupPersonData: {
			get() {
				return this.groupData.groupPerson;
			},
		},
        flagGroup:{
            get() {
				return this.groupData.flagGroup;
			},
        },
        flagGroupCode:{
            get() {
				return this.groupData.flagGroupCode;
			},
        },
        listSubjects: {
			get() {
				return this.groupData.groupCourses;
			}
		},
        UserId: {
            get() {
                return this.$store.state.user_id;
            },
		},
		User: {
            get() {
                return this.$store.state.user;
            },
		},
        DatosSidebar: {
            get() {
                return this.$store.state.datosSidebar;
            }
        },
	},
    async created() {
        let p_step = this.$route.params.step;
        let p_transaction = this.$route.params.transaction;
       
         
        if(p_step == 4 && p_transaction != null){
            let q_token = this.$route.query.token;
            await this.PlanComprado(p_transaction, q_token);
            
        }else{
            let planActive  = await  ValidateIsPlanActive(this.$store.state.user.personStudentId, this.$store.state.authToken);
                    
            if(!planActive){
                hideSidebar(this.$store.state.user, 4, this.$store.state.datosSidebar);
                
                if(!this.flagGroupCode){
                    if(!this.flagGroup){
                        this.stepBuy = 2;
                        this.getGroupInfo(); 
                    }
                }else{
                    this.flagLoaded = true;
                }
 
            }else{
                this.$router.push({ name: `dashboard` }).catch(err => {}); 
            }
        }
    },
    validations: {
        group:{
            code: {
                required
            }    
        }
    },
    watch: {
        group: {
            handler: function(val, oldVal) {
                
                if (this.group.code == "" ){
                    this.message = "";
                }
            },
            deep: true
        }
    }, 
  
    methods: {
        backStepBuy(){
            this.stepBuy--;
        },
        goStepBuy() {
            this.stepBuy = 2;
        },
        goPlanPricesStep() {
            this.$router.push('/compra/'+ 0)
        },
        validationMsgCodeGroup: validationMessage(formMessagesCodeGroup),
        procesarGroupCode: function(){
            if (!this.isLoading) {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }

                this.validateGroupCode();
            }

        },
        validateGroupCode: function() {
            let data = {
                PurchaseCode: this.group.code,
                GroupId: this.groupData.id
            };

            this.isLoading = true;
			baseInstanceAxios
				.post(this.API_URL + `/resources/Groups/ValidateCode`, data)
				.then(response => {
                     
					if (response.data != null) {
						if(response.data.value != null){ 
                            if(response.data.value == 4){
                                
                                this.objInformation = {
                                    code:response.data.entity.code,
                                    purchaseCode: response.data.entity.purchaseCode,
                                    persons: response.data.entity.persons,
                                    company:response.data.entity.plan.company,
                                    duration: response.data.entity.plan.duration,
                                    flagPlanTest: response.data.entity.plan.flagPlanTest,
                                    name: response.data.entity.plan.name,
                                    price: response.data.entity.priceByHours,
                                    strPrice: response.data.entity.strPlanPrice,
                                    months: response.data.entity.plan.meses,
                                    subjects: response.data.entity.listSubjects,
                                    levelAbrev: response.data.entity.levelAbrev,
                                    flagGroup: true,
                                
                                };
                                this.message = this.lstMessages[response.data.value - 1];
                                this.codeValid=true;
                                //this.stepBuy = 2;
                            }
                            else{
                                this.message = this.lstMessages[response.data.value - 1];
                                this.objInformation = {};
                                this.codeValid=false;
                            }
                             
						}else{
                            this.message = response.data.message;
                            this.$bvToast.show("toast-check-modal-error");
                        }
                        this.isLoading = false;
					}
                    
				})
                .catch(function (error) {
                    console.log(error);
                    this.message = this.$t('my-cours.mesage-system-error');
                    this.$bvToast.show("toast-check-modal-error");
                    this.isLoading = false;
                });
         
        },
    
        getGroupInfo:function(){
            
            baseInstanceAxios
				.get(this.API_URL + `/resources/Groups/GetGroupInfo?idGroup=${this.groupData.id}`)
				.then(response => {
   
					if (response.data != null && response.data.entity != null) {
						this.objInformation = {
                            duration: response.data.entity.plan.duration,
                            name: response.data.entity.plan.name,
                            persons: response.data.entity.persons,
                            strPrice: response.data.entity.strPlanPrice,
                            price: response.data.entity.priceByHours,
                            flagPlanTest: response.data.entity.plan.flagPlanTest,
                            months: response.data.entity.plan.meses,
                            flagGroup: response.data.entity.flagGroup,
                            levelAbrev: response.data.entity.levelAbrev ,
                            subjects: response.data.entity.flagGroupCode ? response.data.entity.listSubjects : this.listSubjects
                        };
                        
					}
                    this.isLoading = false;
                    this.flagLoaded = true;
                    
				})
                .catch(function (error) {
                    this.message = this.$t('my-cours.mesage-system-error');
                    this.$bvToast.show("toast-check-modal-error");
                    this.isLoading = false;
                    this.flagLoaded = true;
                });
            
        },

        showNiubizPaymentForm: function(){

            let data = {
                Canal: "web",
                Monto:  this.objInformation.price,
                GroupId: this.groupData.id,
                idPersonStudent : this.$store.state.user.personStudentId,
                amount : this.objInformation.price,
                flagGroup: this.flagGroup,
                user : this.$store.state.user.email,
                flagFrequentClient: this.$store.state.datosSidebar.flagPurchaseHistory ? 1 : 0

            }
            this.isLoading = true;
            this.flagBackgroundLoading = true;

            var sessionKey = "";
            var merchantId = this.NIUBIZ_MERCHANT_ID;
            let amount = this.objInformation.price;

            var interval;

            baseInstanceAxios
				.post(this.API_URL + `/sales/niubiz/token/sesion`, data)
				.then(response => {
                    if(response.data != null && response.data.entity != null){
						sessionKey = response.data.entity.sessionKey;
                        this.PurchaseNumberNiubiz = response.data.entity.purchaseNumberNiubizFormat;

                        let ListSubjectLevelIdStr = this.flagGroupCode ? 
                                            this.objInformation.subjects.map(subject => subject.subjectLevelId).join() : 
                                            this.objInformation.subjects.map(subject => subject.id).join();
                        let groupCode = this.flagGroupCode ? this.group.code : null;
                        var idData = `${this.PurchaseNumberNiubiz}|${this.groupData.id}|${this.objInformation.flagGroup}|${amount}|${ListSubjectLevelIdStr}|${groupCode}`
                        
                        

                        openNiubizCheckoutForm(merchantId, sessionKey, data.Monto, this.PurchaseNumberNiubiz, idData, "", "");
                        let self = this;
                        interval = setInterval(function () {
                           
                        
                            if (document.querySelectorAll("#visaNetWrapper iframe") != null && document.querySelectorAll("#visaNetWrapper iframe")[0].style['display'] == "none") {
                                
                                self.flagBackgroundLoading = false;
                                window.clearInterval(interval);
                                //window.location.reload();
                        }}, 1000);
                    
                    
                    }
                    this.isLoading = false;
                   
				})
                .catch(function (error) {
                    this.message = this.$t('my-cours.mesage-system-error');
                    this.$bvToast.show("toast-check-modal-error");
                    this.isLoading = false;
                    this.flagBackgroundLoading = false;
                });
        },
        async PlanComprado(transaction, tokenTransaction){
            var flagProcesado = transaction == "error" ? false : true;
             
            if(flagProcesado){
                            
                if(transaction != null){
                    this.getGroupInfoByTransaction(transaction, tokenTransaction);
                    
                }else{
                    this.$router.push({ name: `dashboard` }).catch(err => {}); 
                }
                 
            }else{
                console.log("PlanComprado - modalCompra")
                //this.modalCompra = true;

                this.isLoading = false;
                this.flagLoaded = true;
                this.stepBuy = 4;
 
                //let tokenTransaction = this.$route.query.token;

                var jsonTransaccion = atob(decodeURIComponent(tokenTransaction))

                if(jsonTransaccion != null){
                    var datosPago = JSON.parse(jsonTransaccion);
                    var nroPedido = datosPago.NUMEROPEDIDO;
                    var descriptionPago = datosPago.DESCRIPCION;
                    var transaccionFecha = datosPago.TRANSACTIONDATEFORMAT;

                    let entity = datosPago.GroupInfo;
                    let entityArr = entity.split("|");

                    let _persons = entityArr[2].split(",");
                    let persons = [];
                    _persons.forEach(element => {
                        persons.push({
                            id : element.split("-")[0],
                            strFullName: element.split("-")[1],
                            flagRepresentative:  element.split("-")[2] === 'True',
                        });
                         
                    });

                    let _subjects = entityArr[9].split(",");
                    let subjects = [];
                    _subjects.forEach(element => {
                        subjects.push({
                            id : element.split("-")[0],
                            subjectLevelId: element.split("-")[0],
                            name: element.split("-")[1]
                        });
                         
                    });

                    this.objInformation = {
                        duration: parseInt(entityArr[0]),
                        name: entityArr[1],
                        persons: persons,
                        strPrice: entityArr[3],
                        price: parseFloat( entityArr[4]),
                        flagPlanTest: entityArr[5]  === 'True',
                        months: parseInt(entityArr[6]),
                        flagGroup: entityArr[7] === 'True',
                        levelAbrev: entityArr[8] ,
                        subjects:  subjects,
                        code: entityArr[11],
                        purchaseCode: entityArr[12],
                        nroPedido: nroPedido,
                        descriptionPago: descriptionPago,
                        transaccionFecha: transaccionFecha
                    };
                    this.groupData.id = parseInt(entityArr[10]);
                    this.groupData.flagGroup = this.objInformation.flagGroup; 
                     
                    if(this.flagGroupCode){
                        this.group.code = entityArr[12];
                    }
                    
                }
 
                this.$router.push("/compra/4");
                
                //deleteCookie("transaccion");
            }
             

        },
        
        getGroupInfoByTransaction:function(transaction, tokenTransaction){
            
            baseInstanceAxios
				.get(this.API_URL + `/resources/Groups/GetGroupInfoByTransactionid?transaction=${transaction}`)
				.then(response => {
   
					if (response.data != null && response.data.entity != null) {
                        

						this.objInformation = {
                            duration: response.data.entity.plan.duration,
                            name: response.data.entity.plan.name,
                            persons: response.data.entity.persons,
                            strPrice: response.data.entity.strPlanPrice,
                            price: response.data.entity.priceByHours,
                            flagPlanTest: response.data.entity.plan.flagPlanTest,
                            months: response.data.entity.plan.meses,
                            flagGroup: response.data.entity.flagGroup,
                            levelAbrev: response.data.entity.levelAbrev ,
                            subjects:  response.data.entity.listSubjects ,
                            code: response.data.entity.code
                        };

                        //let tokenTransaction = this.$route.query.token;
                        var jsonTransaccion = atob(decodeURIComponent(tokenTransaction));
                        if(jsonTransaccion != null){
                            var datosPago = JSON.parse(jsonTransaccion);
                            this.objInformation.nroPedido = datosPago.NUMEROPEDIDO;
                            this.objInformation.transaccionFecha = datosPago.TRANSACTIONDATEFORMAT;
                            this.objInformation.tarjeta = datosPago.NUMEROTARJETA;
                        }
					}
                    this.isLoading = false;
                    this.flagLoaded = true;
 
                    this.stepBuy = 3;
                    this.UpdateDataInfo();
                    
				})
                .catch(function (error) {
                    this.message = this.$t('my-cours.mesage-system-error');
                    this.$bvToast.show("toast-check-modal-error");
                    this.isLoading = false;
                    this.flagLoaded = true;
                });
            
        },
        
        selectTabMethod(valueid){
            if(!document.querySelector("#icontab"+valueid).classList.contains("fill")){ 
                this.selectTab=!this.selectTab;
                this.paymentMethodSelected = valueid;
            }
        },
        IrSeccionPagar: function(){
            this.isLoading = true;
             
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            }

            this.stepBuy = 2;
            this.isLoading = false;
            
        },
        UpdateDataInfo:function(){
            let json = {
                GroupsId: this.User.groupId != null ? this.User.groupId : 0,
                PersonId: this.User.id,
                PersonStudentId: this.User.personStudentId,
                Page: 0,
                Size: 0,
                TypeSearch: false
            };
				 
            baseInstanceAxios
                .post(`${this.apiURL}/resources/dashboard/GetDataGeneral`, json)
                .then((response) => {
                    
                    if(response.data != null){
                        if(response.data.entity != null ){
                            
                            //DATOS GENERALES DEL SIDEBAR
                            if(response.data.entity.entityGroupScheduleProposal != null){
                                let scheduleValue = response.data.entity.entityGroupScheduleProposal.tipoHorarioProgramado;
                                switch (scheduleValue) {
                                    
                                    case Constants.TYPE_SCHEDULED.UNPROGRAMMED:
                                        this.DatosSidebar.typeScheduled = Constants.TYPE_SCHEDULED.UNPROGRAMMED;
                                        break;
                                    case Constants.TYPE_SCHEDULED.MASS_REQUEST:
                                        this.DatosSidebar.typeScheduled = Constants.TYPE_SCHEDULED.MASS_REQUEST;
                                        break;
                                    case Constants.TYPE_SCHEDULED.DIRECT_REQUEST:
                                        this.DatosSidebar.typeScheduled = Constants.TYPE_SCHEDULED.DIRECT_REQUEST;
                                        break;
                                    case Constants.TYPE_SCHEDULED.SCHEDULED:
                                        this.DatosSidebar.typeScheduled = Constants.TYPE_SCHEDULED.SCHEDULED;
                                        break;
                                }
                                this.$store.commit("mutateDatosSidebar",this.DatosSidebar);
                                this.$store.commit('mutateIsRepresentative', response.data.entity.flagGroupRepresentative);
                            }
 
                            this.DatosSidebar.flagPurchaseHistory = response.data.entity.flagPurchaseHistory;
                            this.DatosSidebar.flagActivePlan = response.data.entity.flagActivePlan;
                            this.DatosSidebar.flagViewMenuOptions = response.data.entity.flagViewMenuOptions;
                            
                            this.$store.commit('mutateDatosSidebar', this.DatosSidebar);
                            this.$store.commit('mutateGroupId',response.data.entity.groupId);
                            this.$store.commit('mutateGroupPersonId',response.data.entity.groupPersonId);

                        }
                        
                    }
                    this.flagLoaded = true;     
 
                });
        },
        ValidarFlagGroup:function(){
            //TODO: Lo sentimos, solo el estudiante representante del grupo puede validar el código de compra.
        }

    }

}
</script>